import React from "react";
import SimpleLookupPage from "./SimpleLookupPage";
import useRestaurantPrices from "../../hooks/useRestaurantPrices";

export default function RestaurantPricesPage() {
    const {
        restaurantPrices,
        loading,
        error,
        fetchRestaurantPrices,
        createRestaurantPrice,
        updateRestaurantPrice,
        deleteRestaurantPrice,
    } = useRestaurantPrices();

    return (
        <SimpleLookupPage
            title="Preise"
            itemLabel="Preis"
            searchLabel="Preise suchen"
            items={restaurantPrices}
            loading={loading}
            error={error}
            fetchItems={fetchRestaurantPrices}
            createItem={createRestaurantPrice}
            updateItem={updateRestaurantPrice}
            deleteItem={deleteRestaurantPrice}
        />
    );
}
